var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"mx-md-4 elevation-1"},[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.divisions,"hide-default-footer":""},scopedSlots:_vm._u([{key:"item.academicLevel",fn:function(ref){
var item = ref.item;
return [_c('span',[_vm._v(_vm._s(_vm._f("getAcademicLevel")(item.academicLevel && item.academicLevel.type)))])]}},{key:"item.actions",fn:function(ref){
var item = ref.item;
return [(!(item.config && item.config.default))?_c('DivisionActions',{attrs:{"selected":item}}):_vm._e()]}}],null,true)})],1)}
var staticRenderFns = []

export { render, staticRenderFns }